module.exports = !require('./_descriptors') && !require('./_fails')(function(){
  return Object.defineProperty(require('./_dom-create')('div'), 'a', {get: function(){ return 7; }}).a != 7;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/._core-js@2.4.1@core-js/library/modules/_ie8-dom-define.js
 ** module id = 162
 ** module chunks = 0 1
 **/